import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketBanner } from './MarketBanner';
import { useGeoLocationConfig } from './useGetGeoLocationConfig';
import { useMarketBanner } from './useMarketBanner';

export const MarketBannerContainer: React.FC<{ language: 'en' | 'es' }> = ({ language }) => {
  const { t } = useTranslation();
  const { bannerState, dismissBanner, goToLocalSite } = useMarketBanner();

  const geolocationConfig = useGeoLocationConfig({
    langcode: language,
    countryName: bannerState.detectedMarket?.countryName ?? '',
    countryCode: bannerState.detectedMarket?.countryCode ?? '',
  });

  const shouldShowBanner =
    bannerState.isVisible && bannerState.detectedMarket && geolocationConfig.siteUrl; // No site URL means no local site to go to

  return (
    <div
      role="region"
      aria-label={t('Location notification')}
      aria-live="polite"
      className={shouldShowBanner ? '' : 'pds-sr-only'}
    >
      {shouldShowBanner && (
        <MarketBanner
          onDismiss={dismissBanner}
          onGoToLocal={goToLocalSite}
          geolocationConfig={geolocationConfig}
        />
      )}
    </div>
  );
};
